export interface Gradient {
  gradientType: string | null;
  gradientDirection: string | null;
  colorList: { color: string | undefined; stop: number | null }[];
}

export function parseGradientString(input?: string): Gradient {
  if (!input)
    return {
      colorList: [],
      gradientDirection: null,
      gradientType: null,
    };

  const gradientRegex = /^(.*?)\((.*?)\)$/i;

  if (gradientRegex.test(input)) {
    const [, gradientType, gradientDataString] = input.match(gradientRegex)!;
    const colorList = parseColors(gradientDataString);
    const gradientDirection = gradientDataString.split(', ')[0] || null;

    return {
      gradientType,
      gradientDirection,
      colorList,
    };
  } else {
    return {
      colorList: [],
      gradientDirection: null,
      gradientType: null,
    };
  }
}

function parseColors(input: string): { color: string | undefined; stop: number | null }[] {
  const colorRegex = /#(?:[0-9a-fA-F]{3,8})/g;
  const stopRegex = /(?:[0-9]{1,3})%/g;
  const colors = input.match(colorRegex);
  const stops = input.match(stopRegex);

  return (
    colors?.map((color, index) => ({
      color,
      stop: stops ? parseFloat(stops[index]) : null,
    })) || []
  );
}
